import { ApiClient } from "../../ApiClient";
import { GetPromotionResponse } from "../schema/GetPromotionResponse"
import { _promotions } from "@/_mock/_home"


export const getPromotion = async (): Promise<GetPromotionResponse> => {

  const client = ApiClient.getInstance()
  const response = await client.get<GetPromotionResponse>("home/Promotions")

  return { data: _promotions }

}